export default {
  getAllowedNameChars({ allowedNameChars }) {
    return allowedNameChars;
  },
  getLang ({ lang }) {
    return lang;
  },
  isAirplusModule ({ ModuleName }){
    return ModuleName === "replacementorderairplus"? true : false;
  }
};
